import React, { createContext, useContext } from 'react';

const NotificationOverlayContext = createContext(false);

export function NotificationOverlayProvider({ open, children }) {
  return (
    <NotificationOverlayContext.Provider value={Boolean(open)}>
      {children}
    </NotificationOverlayContext.Provider>
  );
}

export function useNotificationOverlayOpen() {
  return useContext(NotificationOverlayContext);
}

export default NotificationOverlayContext;
